import axios from 'axios';
import { getFingerprint } from 'storage';

// todo: encapsulate header logic duplicated
const SendFactorForForgotPassword = (login, factor) => {
  console.log('SendFactorForForgotPassword', login, factor);
  const url = '/authentication/api/v1/mortgages/forgot-password/factor';
  const data = { login, factorType: factor.type, key: factor.key };
  const headers = { 'Content-Type': 'application/json' };

  return axios({ method: 'post', url, headers, data });
};

const SendFactorForForgotUsername = (member, factor) => {
  console.log('SendFactorForForgotUsername', member, factor);
  const url = '/authentication/api/v1/forgot-login/factor';
  const { type: factorType, key } = factor;
  const data = { factorType, key, member };
  const headers = { 'Content-Type': 'application/json' };

  return axios({ method: 'post', url, headers, data });
};

const VerifyPasscodeForForgotPassword = (stateToken, factor, passcode) => {
  console.log('VerifyPasscodeForForgotPassword', stateToken, factor, passcode);
  const data = { stateToken: stateToken, factorType: factor.type, passCode: passcode };
  const headers = { 'Content-Type': 'application/json' };

  return axios({ method: 'post', url: '/authentication/api/v1/forgot-password/factor/verify', headers, data });
};

const VerifyPasscodeForForgotUsername = (member, factor, passcode) => {
  console.log('VerifyPasscodeForForgotUsername', member, factor, passcode);

  const data = { factorType: factor.type, passcode, member };
  const headers = { 'Content-Type': 'application/json' };

  return axios({ method: 'post', url: '/authentication/api/v1/forgot-login/factor/verify', headers, data });
};

const SendFactor = (stateToken, factor) => {
  console.log('SendFactor', stateToken, factor);
  const url = '/authentication/api/v1/mortgages/sign-in/factor';
  const data = { stateToken, factorType: factor.type, key: factor.key };
  const headers = { 'Content-Type': 'application/json' };

  return axios({ method: 'post', url, headers, data });
};

const VerifyPasscode = (stateToken, factor, passcode) => {
  console.log('VerifyPasscode', stateToken, factor, passcode);
  const data = { stateToken, factorType: factor.type, passCode: passcode };
  const headers = { 'Content-Type': 'application/json', 'X-Device-Fingerprint': getFingerprint() };

  return axios({ method: 'post', url: '/authentication/api/v1/sign-in/factor/verify', headers, data });
};

const statefulSendFactor = (accessToken, stateToken, factor) => {
  console.log('SendFactor', stateToken, factor);
  const url = '/authentication/api/v2/mfa';
  const data = { stateToken, factorType: factor.type, key: factor.key };
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` };

  return axios({ method: 'post', url, headers, data });
};

const statefulVerifyPasscode = (accessToken, stateToken, factor, passcode) => {
  console.log('VerifyPasscode', stateToken, factor, passcode);
  const data = { stateToken, factorType: factor.type, passCode: passcode };
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
    'X-Device-Fingerprint': getFingerprint(),
  };

  return axios({ method: 'post', url: '/authentication/api/v2/mfa/verify', headers, data });
};

export {
  SendFactor,
  VerifyPasscode,
  SendFactorForForgotPassword,
  VerifyPasscodeForForgotPassword,
  SendFactorForForgotUsername,
  VerifyPasscodeForForgotUsername,
  statefulSendFactor,
  statefulVerifyPasscode,
};
